import React, { useCallback, useRef, useState } from "react";
import { useAppContext } from "lib/state/TextProvider";
import { updateUserProfile } from "lib/api";
import { debounce } from "lib/debounce";

const ManifestationEditor = () => {
  const { state, setUserProfileNeedsReload } = useAppContext();
  const inputBoxRef = useRef<HTMLInputElement | null>(null);
  const [inputValue, setInputValue] = useState<string>(
    state.userProfile?.manifestation || "",
  );

  const handleOnInputChange = useCallback(
    debounce(async (text) => {
      await updateUserProfile({ manifestation: text });
      setUserProfileNeedsReload(true);
    }, 200),
    [],
  );

  return (
    <div className="bg-palette-5 text-palette-2 rounded-lg border-2 border-palette-3 p-4">
      <h2 className="text-lg font-bold mb-2">Intention</h2>
      <div className="flex flex-row items-center">
        <form className="w-full overflow-x-hidden">
          <input
            type="text"
            ref={inputBoxRef}
            className="w-full placeholder-palette-3 bg-palette-4 rounded-lg border-2 border-palette-3 p-4 focus:outline-none"
            placeholder={"Set your intention"}
            value={inputValue}
            onChange={(e) => {
              setInputValue(e.target.value);
              handleOnInputChange(e.target.value);
            }}
          />
        </form>
      </div>
    </div>
  );
};

export default ManifestationEditor;
